exports = module.exports = require("../../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".Jrszt17eYEgj4LzJm2bHa{line-height:30px;font-size:19px}._2tKQp2q6nRrUvgjVQ8YijH{font-size:15px;color:var(--neutralPrimary)}._197ieWzIvL2uj2hdvES7JY{color:var(--neutralSecondary);display:-webkit-box;display:-ms-flexbox;display:flex}html[dir] ._36-IosZ47l8VtMaQk8W7r_:hover{background-color:var(--neutralTertiaryAlt)}._36-IosZ47l8VtMaQk8W7r_:focus{outline:none!important}html[dir] ._36-IosZ47l8VtMaQk8W7r_:focus{background-color:var(--themeLighter)}", ""]);
// Exports
exports.locals = {
	"roomIcon": "Jrszt17eYEgj4LzJm2bHa",
	"roomPersonaPrimaryText": "_2tKQp2q6nRrUvgjVQ8YijH",
	"roomPersonaSecondaryText": "_197ieWzIvL2uj2hdvES7JY",
	"roomPersona": "_36-IosZ47l8VtMaQk8W7r_"
};